export default {
	tenantId: "insuredNomads_uat",
	appId: "admin_portal"
}
